function getDeepProperty(obj, path) {
  return path.split('.').reduce((acc, part) => {
    return acc && acc[part];
  }, obj);
}

/**
 * Removes a component from UI instructions that matches the given text and id
 * @param {Function} setInstructions - State setter function for instructions
 * @param {string} instructionId - ID of the instruction to remove the component from
 * @param {object} conditions - Conditions to match in component
 */
const removeFromInstructions = (setInstructions, instructionId, conditions) => {
  setInstructions((currentInstructions) => {
    return currentInstructions.map((instruction) => {
      // If instructionId is provided, only remove the component from the specific instruction
      if (
        (instructionId && instruction.id !== instructionId) ||
        !instruction?.attributes ||
        Object.keys(instruction?.attributes).length === 0 ||
        !instruction?.attributes?.uiInstructions ||
        instruction?.attributes?.uiInstructions?.length === 0
      ) {
        return instruction;
      }

      // Get UI instructions array from instruction
      const uiInstructions = instruction.attributes?.uiInstructions;
      // Filter out matching component
      const filteredInstructions = uiInstructions.filter((uiInstruction) => {
        const matches = Object.entries(conditions).map(([key, value]) => {
          return getDeepProperty(uiInstruction, key) !== value;
        });
        const shouldKeep = matches.some((match) => match);
        return shouldKeep;
      });

      // Update instruction with filtered UI instructions
      return {
        ...instruction,
        attributes: {
          ...instruction.attributes,
          uiInstructions: filteredInstructions
        }
      };
    });
  });
};

export default removeFromInstructions;
